import { getAuthenticatedInstance } from './helpers/axios.helpers';

const authenticatedInstance = getAuthenticatedInstance();

export async function getHierarchy(): Promise<any> {
  return authenticatedInstance.get('/organization_hierarchy');
}
